import { useLocalStorage } from '@vueuse/core'
import { UserGuide } from '@/types/onboarding'
import { buildDropeeStorageKey } from '@/config/config'

export const useGuide = () => {

  const guideModals = useLocalStorage<UserGuide[] | null>(buildDropeeStorageKey('guidesToShow'), [])

  function initGuide() {
    guideModals.value = [UserGuide.Quests, UserGuide.Improve, UserGuide.LoyaltyLeaderboard]
  }

  function shouldShowGuide(guide: UserGuide) {
    return guideModals.value?.includes(guide) ?? false
  }

  function removeGuide(guide: UserGuide) {
    if (!guideModals.value) return
    guideModals.value = guideModals.value.filter((item: UserGuide) => item !== guide)
  }

  return {
    initGuide,
    shouldShowGuide,
    removeGuide,
  }
}
